/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListToolsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * The type of tool
 */
export const ToolTypes = {
  Http: "http",
  Prompt: "prompt",
  Function: "function",
  Platform: "platform",
  Externalmcp: "externalmcp",
} as const;
/**
 * The type of tool
 */
export type ToolTypes = ClosedEnum<typeof ToolTypes>;

export type ListToolsRequest = {
  /**
   * The cursor to fetch results from
   */
  cursor?: string | undefined;
  /**
   * The number of tools to return per page
   */
  limit?: number | undefined;
  /**
   * The deployment ID. If unset, latest deployment will be used.
   */
  deploymentId?: string | undefined;
  /**
   * Filter tools by URN prefix (e.g. 'tools:http:kitchen-sink' to match all tools starting with that prefix)
   */
  urnPrefix?: string | undefined;
  toolTypes?: Array<ToolTypes> | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListToolsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListToolsSecurity$outboundSchema: z.ZodMiniType<
  ListToolsSecurity$Outbound,
  ListToolsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listToolsSecurityToJSON(
  listToolsSecurity: ListToolsSecurity,
): string {
  return JSON.stringify(
    ListToolsSecurity$outboundSchema.parse(listToolsSecurity),
  );
}

/** @internal */
export const ToolTypes$outboundSchema: z.ZodMiniEnum<typeof ToolTypes> = z.enum(
  ToolTypes,
);

/** @internal */
export type ListToolsRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  deployment_id?: string | undefined;
  urn_prefix?: string | undefined;
  tool_types?: Array<string> | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListToolsRequest$outboundSchema: z.ZodMiniType<
  ListToolsRequest$Outbound,
  ListToolsRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    deploymentId: z.optional(z.string()),
    urnPrefix: z.optional(z.string()),
    toolTypes: z.optional(z.array(ToolTypes$outboundSchema)),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      urnPrefix: "urn_prefix",
      toolTypes: "tool_types",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listToolsRequestToJSON(
  listToolsRequest: ListToolsRequest,
): string {
  return JSON.stringify(
    ListToolsRequest$outboundSchema.parse(listToolsRequest),
  );
}
